import script from "./supplement-facts-row.vue?vue&type=script&setup=true&lang=js"
export * from "./supplement-facts-row.vue?vue&type=script&setup=true&lang=js"

import "./supplement-facts-row.vue?vue&type=style&index=0&id=1991ef7c&lang=scss"

const __exports__ = script;

export default __exports__